// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloadsList__container-a461c6 {
  width: 100%;
  background-color: var(--base-0);
  border-top: 1px solid var(--base-20);
  max-height: 0;
  overflow: hidden;
  transition: max-height var(--all-downloads-show-transition);
  will-change: max-height;
  position: absolute;
  bottom: 0;
  padding-bottom: 43px;
}

.AllDownloadsList__container-a461c6.AllDownloadsList__open-b4eb77 {
  border-radius: 16px 16px 0 0;
  box-shadow: 0 8px 9px 0 rgba(0, 0, 0, 0.1);
}

.AllDownloadsList__inner-container-ddef75 {
  max-height: 339px;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloadsList/AllDownloadsList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,+BAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,2DAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;AACF;;AAEA;EACE,4BAAA;EACA,0CAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n  background-color: var(--base-0);\n  border-top: 1px solid var(--base-20);\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height var(--all-downloads-show-transition);\n  will-change: max-height;\n  position: absolute;\n  bottom: 0;\n  padding-bottom: 43px;\n}\n\n.container.open {\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 8px 9px 0 rgba(0, 0, 0, 0.1);\n}\n\n.inner-container {\n  max-height: 339px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloadsList__container-a461c6`,
	"open": `AllDownloadsList__open-b4eb77`,
	"inner-container": `AllDownloadsList__inner-container-ddef75`,
	"innerContainer": `AllDownloadsList__inner-container-ddef75`
};
module.exports = ___CSS_LOADER_EXPORT___;
